(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/middlewares/middlewares.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/middlewares/middlewares.js');
"use strict";


const _svs$components$marke = svs.components.marketplaceCompetition.services.middlewares,
  analyticsMw = _svs$components$marke.analyticsMw,
  makeCompetitionMw = _svs$components$marke.makeCompetitionMw,
  kibanaMw = _svs$components$marke.kibanaMw;
const competitionMiddlewares = [makeCompetitionMw, analyticsMw, kibanaMw];
setGlobal('svs.components.marketplaceCompetition.services.middlewares.competitionMiddlewares', competitionMiddlewares);

 })(window);